export function TransformRawObjectData(obj) {
  if (!obj || typeof obj !== "object") return [];

  return Object.entries(obj).map(([key, value]) => ({
    name: key,
    value: value,
  }));
}
